import {Input} from 'antd';

import styled from 'styled-components';

export const SearchInput = styled(Input)`
  height: 46px;
  width: auto;
`;
